<div class="w-full h-full" fxLayout="column" fxLayoutAlign="center center">
    <div class="overflow-hidden w-full max-w-xs">
      <div class="p-6 pb-0" fxLayout="column" fxLayoutAlign="center center">
        <div class="fill-current text-center">
          <img class="w-16" src="assets/img/demo/logo.svg">
        </div>
      </div>
  
      <div class="text-center mt-4">
        <h2 class="title m-0">Welcome back</h2>
        <h4 class="body-2 text-secondary m-0">Sign in with your credentials below.</h4>
      </div>
  
      <form [formGroup]="userEmailLogin" #emailLoginForm="ngForm" class="p-6" fxLayout="column" fxLayoutGap="16px">
        <div fxFlex="auto" fxLayout="column">
          <mat-form-field fxFlex="grow">
            <mat-label>E-Mail</mat-label>
            <input formControlName="login_email" matInput required>
            <mat-error *ngIf="userEmailLogin.get('login_email').hasError('required')">Email Id cannot be blank</mat-error>
            <!-- <mat-error *ngIf="userEmailLogin.get('login_email').hasError('pattern')">Email Id is not correct</mat-error> --> 
            <mat-error *ngIf="userEmailLogin.get('login_email').hasError('email')">Email Id is invalid</mat-error>
            <mat-error *ngIf="userEmailLogin.get('login_email').hasError('cannotContainSpace')">Username can not contain space.</mat-error>
          </mat-form-field>
          <mat-form-field fxFlex="grow" class="mt-2">
            <mat-label>Password</mat-label>
            <input [type]="inputType" formControlName="login_email_password" matInput required (keypress)="checkWhitSpaces($event)">
            <button (click)="toggleVisibility()" mat-icon-button matSuffix matTooltip="Toggle Visibility" type="button">
              <mat-icon *ngIf="visible" [icIcon]="icVisibility"></mat-icon>
              <mat-icon *ngIf="!visible" [icIcon]="icVisibilityOff"></mat-icon>
            </button>
            <mat-hint>Click the eye to toggle visibility</mat-hint>
            <mat-error *ngIf="userEmailLogin.get('login_email_password').hasError('required')">Password cannot be blank</mat-error>
            <mat-error  *ngIf="userEmailLogin.get('login_email_password').hasError('minlength')">Password Minimum
              length is 6 characters</mat-error>
          </mat-form-field>
        </div>
  
        <!-- <div fxLayout="row" fxLayoutAlign="space-between center">
          <mat-checkbox class="caption" color="primary">Remember Me</mat-checkbox>
          <a [routerLink]="['/forgot-password']" class="caption">Forgot Password?</a>
        </div> -->
  
        <button (click)="onUserEmailLogin(userEmailLogin)"  id="signin-btn" mat-raised-button [disabled]="!userEmailLogin.valid" type="button">
          SIGN IN
        </button>
  
        <!-- <p class="text-secondary text-center">
          Don't have an account?<br/>
          <a [routerLink]="['/register']">Click here to create one</a>
        </p> -->
      </form>
    </div>
  </div>
  